import { createSelector } from 'reselect';
import { activeItemSelector, hasActiveSearchBarSelector, userSelector, hasPredictiveSearchSelector, predictiveSearchSelector, activatePredictiveSearchBarSelector, deactivatePredictiveSearchBarSelector, searchTermSelector, triggerPredictiveSearchInputSelector, executeSearchTrackingSelector, } from '@xingternal/platform-layout-selectors';
export default createSelector(activeItemSelector, hasActiveSearchBarSelector, userSelector, hasPredictiveSearchSelector, predictiveSearchSelector, activatePredictiveSearchBarSelector, deactivatePredictiveSearchBarSelector, searchTermSelector, triggerPredictiveSearchInputSelector, executeSearchTrackingSelector, (activeItem, hasActiveSearchBar, user, hasPredictiveSearch, predictiveSearch, activatePredictiveSearchBar, deactivatePredictiveSearchBar, searchTerm, triggerPredictiveSearchInput, executeSearchTracking) => {
    return {
        activeItem,
        hasActiveSearchBar,
        user,
        hasPredictiveSearch,
        predictiveSearch,
        activatePredictiveSearchBar,
        deactivatePredictiveSearchBar,
        searchTerm,
        triggerPredictiveSearchInput,
        executeSearchTracking,
    };
});
//# sourceMappingURL=selectors.js.map